import { PrimeStatus } from '@src/types';
export function CheckAccess(data: PrimeStatus[] | undefined) {
  if (
    data === undefined ||
    data[1]?.daysRemaining === undefined ||
    data[0]?.daysRemaining === undefined
  ) {
    return 0;
  }
  if (data[1]?.daysRemaining === 0 && data[0]?.daysRemaining === 0) {
    return 0;
  }
  if (data[1]?.daysRemaining === 0 && data[0]?.daysRemaining > 0) {
    return 1;
  } else if (data[1]?.daysRemaining > 0 && data[0]?.daysRemaining === 0) {
    return 2;
  } else {
    return 3;
  }
}
